const DEFAULT_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const DEFAULT_WARNING_LEAD_MS = 2 * 60 * 1000;

const parseMs = (raw: string | undefined, fallback: number): number => {
  const parsed = Number(raw);
  return raw && Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

/** FR-009: configurable via env var, not a hard-coded constant. */
export const IDLE_TIMEOUT_MS = parseMs(import.meta.env.VITE_IDLE_TIMEOUT_MS, DEFAULT_IDLE_TIMEOUT_MS);
export const WARNING_LEAD_MS = parseMs(
  import.meta.env.VITE_IDLE_WARNING_LEAD_MS,
  DEFAULT_WARNING_LEAD_MS,
);

export const IDLE_ACTIVITY_CHANNEL_NAME = 'claimos-idle-activity';
